"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Contract = __importStar(require("@tableau/api-external-contract-js"));
const api_shared_js_1 = require("@tableau/api-shared-js");
const Dashboard_1 = require("./Dashboard");
const Story_1 = require("./Story");
const Worksheet_1 = require("./Worksheet");
class StoryPoint {
    constructor(_storyPointImpl, _workbookImpl) {
        this._storyPointImpl = _storyPointImpl;
        this._workbookImpl = _workbookImpl;
    }
    get index() {
        return this._storyPointImpl.index;
    }
    get caption() {
        return this._storyPointImpl.caption;
    }
    get active() {
        return this._storyPointImpl.active;
    }
    get updated() {
        return this._storyPointImpl.updated;
    }
    get containedSheet() {
        const containedSheet = this._storyPointImpl.containedSheet;
        if (!containedSheet) {
            return undefined;
        }
        switch (containedSheet.sheetType) {
            case Contract.SheetType.Worksheet: {
                return new Worksheet_1.Worksheet(containedSheet, this._workbookImpl);
            }
            case Contract.SheetType.Dashboard: {
                return new Dashboard_1.Dashboard(containedSheet, this._workbookImpl);
            }
            case Contract.SheetType.Story: {
                throw new api_shared_js_1.TableauError(Contract.EmbeddingErrorCodes.ImplementationError, 'A story cannot contain another story');
            }
            default: {
                throw new api_shared_js_1.TableauError(Contract.EmbeddingErrorCodes.ImplementationError, 'Unable to initialize contained sheet');
            }
        }
    }
    get parentStory() {
        return new Story_1.Story(this._storyPointImpl.parentStory, this._workbookImpl);
    }
}
exports.StoryPoint = StoryPoint;
//# sourceMappingURL=StoryPoint.js.map